"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Base = _interopRequireDefault(require("./Base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Extraingredient extends _Base.default {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "type", 'extraingredient');

    _defineProperty(this, "getPrice", () => {
      var _this$sizes;

      return (((_this$sizes = this.sizes) === null || _this$sizes === void 0 ? void 0 : _this$sizes.length) > 0 ? +this.sizes[0].price : +this.price) * (+this.quantity || 0);
    });

    _defineProperty(this, "toJSON", () => {
      let me = this,
          _this = {};
      ['_id', 'ref_id', 'parent', 'position', 'type', 'name', 'description', 'price', 'originalPrice', 'new', 'delete', 'show', 'selected', 'quantity', 'observation', 'sizes', 'availability'].map(prop => {
        _this[prop] = me[prop];
      });
      ['position', 'quantity', 'price', 'originalPrice'].map(prop => {
        if (me[prop] !== null && +me[prop] !== NaN) {
          _this[prop] = +me[prop];
        }
      });
      return _this;
    });
  }

}

exports.default = Extraingredient;